/**
 * welcome-guest.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { AuthService } from "../auth/auth.service";
import { PasswordCredentials } from "../auth/identity/credentials";
import { LoginService } from "../auth/login.service";
import { AlertService } from "./alert.service";
import { BrandingService } from "./branding.service";
import { Router } from "@angular/router";
import { SubjectService } from "app/subjects/subject.service";
import { AlgorithmService } from "app/algorithms/management/algorithm.service";
import { Algorithm } from "app/algorithms/structure";

/**
 * The {@link WelcomeGuestComponent} displays a modified front page of the
 * application for consumption by (prospective) guest users.
 */
@Component({
  template: `
  <div class="inset-background welcome-mat">
    <div class="container">
      <table class="splash center-block">
        <tr>
          <td rowspan="2">
            <img src="zone/images/splash_logo.png" class="logo">
          </td>
          <td class="title-box">
            <h4 class="pretitle">{{branding.strings.splash_pretitle}}</h4>
            <h1 class="title">
              {{branding.strings.splash_title}}
              <span
                *ngIf="branding.flags.has('use_title_trademark')"
                class="title-tm">
                ™️
              </span>
            </h1>
          </td>
        </tr>
        <tr>
          <td class="explanation">
            <p>
              {{branding.strings.splash_tagline}}
            </p>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div class="container loginForm">
    <div *ngIf="!auth.authenticated" class="row">
      <div class="col-sm-6 col-sm-offset-3 form-group">
        <button
          class="btn btn-primary form-control align-with-labels"
          (click)="attemptGuestLogIn()"
          [disabled]="!login.ready">
          Start Guest Session
        </button>
      </div>
    </div>
    <h3 class="info row text-center" *ngIf="auth.authenticated">
      You have already started your session!
    </h3>
  </div>

  <div class="inset-background">
    <div class="container">
      <table class="grant-info center-block">
        <tr>
          <td>
            <p>
              Advocus is a product of My Coverage Plan,
              a subsidiary of ABC for Health, Inc.
            </p>
            <p>
              My Coverage Plan was made possible in part by grant number
              <cite>5R43MD005810-02</cite> from the National Institute on
              Minority Health and Health Disparities.
            </p>
          </td>
          <td>
            <img src="zone/images/mcp_logo.png" class="logo mcp">
          </td>
          <td>
            <img src="zone/images/abc_logo.png" class="logo abc">
          </td>
        </tr>
      </table>
    </div>
  </div>
  `,
  styles: [``]
})
export class WelcomeGuestComponent
{

  /**
   * Construct a new {@link WelcomeGuestComponent}.
   *
   */
  public constructor (
    protected auth : AuthService,
    protected login : LoginService,
    protected alerts : AlertService,
    public branding : BrandingService,
    protected router : Router,
    protected subjects : SubjectService,
    protected algorithms : AlgorithmService
  ) {}

  /**
   * Use the {@link AuthService} to attempt a login, and redirect if the attempt
   * was successful.
   *
   * @return {boolean} Always false, to prevent HTML form submit navigation.
   */
  public attemptGuestLogIn () : boolean
  {
    this.auth.guestLogin().subscribe((success : boolean) => {
      if (success)
      {
        const alg : Algorithm | null = this.algorithms.findAlgorithm("a-tlc");
        console.warn(alg);
        if (alg)
        {
          this.subjects.launchNew(alg);
        }
      }
      else
      {
        this.alerts.warnAndReplace(
          "Your username and/or password are incorrect. Please try again.",
          "credential failure");
      }
    });
    return false;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/common/welcome-guest.component.ts